import jQuery from "jquery";
import React from "react";
import classNames from "classnames";
import {Image} from "./image";
import ListHelper from "./list-helper";
import Debouncer from "../tools/debouncer";

export default class extends React.Component {
	constructor(props) {
		super(props);
        this.items = new ListHelper(this.props.items, () => this._update());
		this.state = {
			counter: 0
		};
	}

	componentDidMount() {
		const resizeDebouncher = new Debouncer(100);
		jQuery(window).resize(() => resizeDebouncher.debounce(() => this.setState()));

		/**
		 * Wenn man mit einem Trackpad (Mac et al) scrollt, dann muss die Scrollrate
		 * begrenzt werden.
		 */
		const moveDebouncher = new Debouncer(50);
		const move = (offset, e) => {
            moveDebouncher.prevent(() => this._moveCursor(offset));
			e.preventDefault();
		};

		// Firefox
		jQuery(this.refs.panel).on('DOMMouseScroll', e => move(e.originalEvent.detail > 0 ? -1 : 1, e));
		// IE, Opera, Safari
		jQuery(this.refs.panel).on('mousewheel', e => move(e.originalEvent.wheelDelta < 0 ? 1 : -1, e));

		setTimeout(() => this.setState(), 500);
	}

	getThumbnail(item) {
		switch(item.type) {
			case 'yt': return <Image onClick={() => this._activateImage(item)} image={{alt: item.alt, lores: item.thumb, hires: item.thumb, zoom: item.thumb}} />;
			case 'image':
			default: return <Image onClick={() => this._activateImage(item)} image={{alt: item.alt, lores: item.lores, hires: item.lores, zoom: item.lores}} />;
		}
	}

	render() {
		const items = this._getItems();
		return (
			<div className={classNames({"element--image-gallery--navigation": true, "scrollable": this._isScrollable()})}>
				{this.props.items.length > 5 &&
					<div className="element--image-gallery--navigation--arrow-up" onClick={() => this.items.prev()}>
						<i className="fa fa-arrow-up" aria-hidden="true" />
						<i className="fa fa-arrow-left" aria-hidden="true" />
					</div>
				}
				<div className="element--image-gallery--navigation--images" ref="container">
					<div style={{marginTop: (-this._getNegativeOffset()) + 'px'}} ref="panel">
						{items.map((item) =>
							<div className={classNames({'element--image-gallery--navigation--image': true, 'active': item.active})}>
								{this.getThumbnail(item)}
							</div>
						)}
					</div>
				</div>
				{this.props.items.length > 5 &&
					<div className="element--image-gallery--navigation--arrow-down" onClick={() => this.items.next()}>
						<i className="fa fa-arrow-right" aria-hidden="true" />
						<i className="fa fa-arrow-down" aria-hidden="true" />
					</div>
				}
			</div>
		)
	}

	_activateImageByIndex(idx) {
		this.props.items.forEach(item => item.active = false);
		this.props.items[idx].active = true;
		this._update();
	}

	_activateImage(item) {
		this.props.items.forEach(item => item.active = false);
		if(item !== null) {
			item.active = true;
		}
		this.props.items.forEach((item, idx) => item.active && this._setCursor(idx));
	}

	_moveCursor(relativePos) {
		this.state.counter = this.state.counter + relativePos;
		this.state.counter = Math.max(this.state.counter, 0);
		this.state.counter = Math.min(this.state.counter, this._getItems().length - 1);
		this._setCursor(this.state.counter);
	}

	_setCursor(cursor) {
		this._activateImageByIndex(cursor);
		this.setState({counter: cursor});
	}

	_getNegativeOffset() {
		const imagesHeight = this._getVisibleHeight();
		const imagesScroll = this._getScrollHeight();
		const imageCount = Math.max(this._getItems().length - 1, 1);
		if(!this._isScrollable()) {
			return 0;
		}
		const offset = (this.state.counter / imageCount) * (imagesScroll - imagesHeight);
		return Math.floor(offset);
	}

	_isScrollable() {
		const imagesHeight = this._getVisibleHeight();
		const imagesScroll = this._getScrollHeight();
		return imagesScroll > imagesHeight;
	}

	_getVisibleHeight() {
		return jQuery(this.refs.container).height();
	}

	_getScrollHeight() {
		return jQuery(this.refs.panel).prop("scrollHeight");
	}

	_getItems() {
		return this.props.items instanceof Array ? this.props.items : [];
	}

	_update() {
		this.props.items.forEach(item => {
			if(item.active) {
                this.props.onChange(item);
            }
		});
        this.setState();
	}
}
